import styled from '@emotion/styled';
import {has} from 'lodash';

const BaseRow = styled.div`
  display: grid;
  display: -ms-grid;
  width: 100%;
  margin-bottom: 16px;
  box-sizing: border-box;
  
  font-family: ${props => props.theme.fontFamily};
  color: ${props => props.theme.primaryColor};
  font-size: 12px;
  line-height: 18px;
  font-weight: 600;
    
  border-radius: ${props => !has(props.theme, 'blockBorderRadius') ? '10' : props.theme.blockBorderRadius}px;
  border: 1px solid ${props => props.theme.borderColor};
  background-color: ${props => props.theme.cardColor};

  &:last-of-type { margin-bottom: 0; }
  
  &:hover {
    border-color: ${props => props.theme.cardColor};
    box-shadow: 0 0 16px rgba(0, 0, 0, 0.16);
  }
`;

export default BaseRow;
